<div class="sales-report-layout">
    <!-- Toolbar -->
    <p-toolbar styleClass="report-toolbar mb-3">
        <div class="p-toolbar-group-start">
            <p-button icon="pi pi-arrow-left" label="Back" styleClass="p-button-text p-button-sm" (click)="back()"> </p-button>
        </div>
        <div class="p-toolbar-group-end">
            <span class="toolbar-date">{{ today | date: 'dd.MM.yyyy' }}</span>
            <p-button icon="pi pi-cloud-download" label="Export PDF" styleClass="p-button-primary p-button-sm" (click)="exportToPDF()">
            </p-button>
        </div>
    </p-toolbar>

    <!-- Report Content -->
    <div class="report-content" #pdfContent>
        <!-- Main Content -->
        <div class="main-content">
            <router-outlet></router-outlet>
        </div>

        <!-- Footer -->
        <app-card>
            <div class="report-footer">
                <div class="footer-left">
                    <div class="logo-container" *ngIf="logoPath">
                        <img [src]="logoPath" alt="Company Logo" />
                    </div>
                    <div class="footer-company-info">
                        <span class="footer-company">{{ companyName }}</span>
                        <span class="footer-address">{{ address }}</span>
                    </div>
                </div>
                <p-divider layout="vertical" styleClass="footer-divider"></p-divider>
                <div class="footer-right">
                    <span class="footer-contact-label">For any questions please contact us at</span>
                    <span class="footer-contact-email">{{ email }}</span>
                </div>
            </div>
        </app-card>
    </div>
</div>
